export default __webpack_public_path__ + "static/media/drop-2-blue.151f5c72.jpg";